"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlansInfo = void 0;
const react_1 = __importDefault(require("react"));
require("./plans-info.css");
const lang = __importStar(require("./lang.json"));
;
;
;
/**
 * Main component.
 * @name plansInfo
 * @param {PlanInfoProps}
 * @returns {<PlansInfo />}
*/
const PlansInfo = ({ title = lang.title, description, mobileInfo = undefined, plans }) => {
    const [currentPlan, setCurrentPlan] = react_1.default.useState(-1);
    const handleClick = (index) => {
        setCurrentPlan(currentPlan !== index ? index : -1);
    };
    const mobileContent = (react_1.default.createElement("div", { className: "price-card-mobile d-lg-none" },
        react_1.default.createElement("div", { className: "mobile-title" },
            react_1.default.createElement("span", null, mobileInfo === null || mobileInfo === void 0 ? void 0 : mobileInfo.title)),
        react_1.default.createElement("div", { className: "mobile-quote-desc" },
            react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: (mobileInfo === null || mobileInfo === void 0 ? void 0 : mobileInfo.quoteDesc) || '' } }),
            react_1.default.createElement("span", { className: "mobile-price price-card-number-mobile" },
                "$", mobileInfo === null || mobileInfo === void 0 ? void 0 :
                mobileInfo.price))));
    const planContent = (item, index) => {
        return (react_1.default.createElement("div", { key: index, className: `plan-info ${currentPlan === index ? 'opened' : ''}`, onClick: () => handleClick(index) },
            react_1.default.createElement("p", { className: "plan-title" }, item.title),
            react_1.default.createElement("p", { className: "plan-description" }, item.description)));
    };
    return (react_1.default.createElement("div", { className: "plansinfo-container", "data-testid": "plansinfo-element" },
        mobileInfo && mobileContent,
        react_1.default.createElement("div", { className: "plans-info-title" },
            react_1.default.createElement("span", null, title)),
        react_1.default.createElement("div", { className: "plans-info-subtitle" },
            react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: description } })),
        plans.map((item, i) => { return planContent(item, i); })));
};
exports.PlansInfo = PlansInfo;
//# sourceMappingURL=plans-info.js.map